
import { useState, useEffect } from 'react';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/6a6cc57929d19c4f05e35d6a1c136bd6.jpg',
    title: 'Premium Spa & Salon Solutions',
    subtitle: 'Elevating Beauty & Wellness Experiences Worldwide'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=high%20quality%20medical%20spa%20equipment%20and%20professional%20beauty%20devices%20arranged%20elegantly%20on%20clean%20white%20surface%20with%20soft%20lighting%20modern%20healthcare%20aesthetic%20minimalist%20background%20professional%20product%20photography&width=1920&height=1080&seq=hero2&orientation=landscape',
    title: 'Medical Grade Products',
    subtitle: 'Trusted by Professionals Across the Globe'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=elegant%20beauty%20salon%20with%20professional%20hairstyling%20stations%20modern%20mirrors%20comfortable%20chairs%20premium%20hair%20care%20products%20displayed%20beautifully%20clean%20white%20interior%20with%20gold%20accents%20luxury%20atmosphere%20professional%20photography&width=1920&height=1080&seq=hero3&orientation=landscape',
    title: 'Excellence in Every Detail',
    subtitle: 'Your Partner in Beauty & Healthcare Innovation'
  }
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="container mx-auto px-4 text-center w-full">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in">
            {slides[currentSlide].title}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
            {slides[currentSlide].subtitle}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-8 py-4 rounded-full text-base font-medium hover:bg-teal-700 transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Get In Touch
          </button>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
